import { render, staticRenderFns } from "./ChecklistCampo.vue?vue&type=template&id=50d3a6c5&scoped=true"
import script from "./ChecklistCampo.vue?vue&type=script&lang=js"
export * from "./ChecklistCampo.vue?vue&type=script&lang=js"
import style0 from "./ChecklistCampo.vue?vue&type=style&index=0&id=50d3a6c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3a6c5",
  null
  
)

export default component.exports